'use client'

import { useEffect, useRef } from 'react'

export default function useResizeObserver<T extends HTMLElement = HTMLElement>(
  target: React.RefObject<T>,
  callback: ResizeObserverCallback,
  options?: ResizeObserverOptions
) {
  const callbackRef = useRef<ResizeObserverCallback | undefined>(undefined)
  callbackRef.current = callback

  useEffect(() => {
    const element = target.current

    if (!element) return

    if (typeof window === 'undefined' || !('ResizeObserver' in window)) return

    const observer = new ResizeObserver((entries, observer) => {
      callbackRef.current?.(entries, observer)
    })

    observer.observe(element, options)

    return () => {
      observer.disconnect()
    }
  }, [options, target])
}
